import { useEffect, useState } from "react";
import { Home, LayoutGrid, MapPin, Briefcase, MessageCircle, Download, X } from "lucide-react";
import { APP_LINKS } from "@/data/site";

const ITEMS = [
  { id: "top", label: "Home", icon: Home },
  { id: "services", label: "Services", icon: LayoutGrid },
  { id: "cities", label: "Cities", icon: MapPin },
  { id: "partner", label: "Partner", icon: Briefcase },
  { id: "contact", label: "Contact", icon: MessageCircle },
];

export default function BottomNav() {
  const [active, setActive] = useState("top");
  const [showInstall, setShowInstall] = useState(true);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY + 120;
      let current = "top";
      for (const it of ITEMS) {
        const el = document.getElementById(it.id);
        if (el && el.offsetTop <= y) current = it.id;
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 px-3 pb-[env(safe-area-inset-bottom)]"
    >
      {/* Slim sticky Install AzoApp bar */}
      {showInstall && (
        <div
          data-testid="mobile-install-bar"
          className="mx-auto mb-2 flex max-w-md items-center gap-2.5 rounded-2xl bg-azo-primary text-white px-3 py-2 shadow-azo"
        >
          <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-white/15">
            <Download size={16} />
          </span>
          <div className="min-w-0 flex-1 leading-tight">
            <p className="truncate text-[13px] font-heading font-bold">Install AzoApp</p>
            <p className="truncate text-[10px] text-white/80">Book faster — free on Google Play</p>
          </div>
          <a
            href={APP_LINKS.customer}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="install-bar-get-app"
            className="shrink-0 rounded-full bg-white px-3 py-1.5 text-xs font-heading font-semibold text-azo-primary"
          >
            Get App
          </a>
          <button
            onClick={() => setShowInstall(false)}
            aria-label="Dismiss install bar"
            data-testid="install-bar-close"
            className="grid h-7 w-7 shrink-0 place-items-center rounded-full text-white/80 hover:bg-white/15 hover:text-white"
          >
            <X size={15} />
          </button>
        </div>
      )}
      <div className="mx-auto mb-3 flex max-w-md items-center justify-between rounded-[1.6rem] border border-azo-border bg-azo-surface shadow-azo px-2 py-1.5">
        {ITEMS.map((it) => {
          const isActive = active === it.id;
          const Icon = it.icon;
          return (
            <a
              key={it.id}
              href={`#${it.id}`}
              data-testid={`bottomnav-${it.id}`}
              aria-label={it.label}
              className="relative flex flex-1 flex-col items-center gap-0.5 rounded-2xl py-2 transition-colors duration-300"
            >
              <span
                className={`grid h-9 w-9 place-items-center rounded-xl transition-all duration-300 ${
                  isActive ? "bg-azo-primary text-white shadow-azo -translate-y-0.5" : "text-azo-muted"
                }`}
              >
                <Icon size={19} />
              </span>
              <span className={`text-[10px] font-medium ${isActive ? "text-azo-primary" : "text-azo-muted"}`}>
                {it.label}
              </span>
            </a>
          );
        })}
      </div>
    </nav>
  );
}
